import moment from "moment";
import React, { Fragment, useState } from "react"
import 'react-image-lightbox/style.css';
import { useHistory } from "react-router";
import { Link } from "react-router-dom";
import { Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, Table, UncontrolledDropdown } from "reactstrap";
import iconSub from '../../../assets/images/icon-sub.png';
import profilePic from '../../../assets/images/users/no-img.jpg';
import ModalPopup from "../../../components/ModalPopup";
import NavTabNutri from "../../../components/NavTabNutri";
import RowEmpty from "../../../components/RowEmpty";
import PriceUtils from "../../../helpers/PriceUtils";
import ReceiptsAdd from "../../receipts/ReceiptsAdd";
import { getDetailSource } from "../../supplier/components/SupplierTab";
import TextUtils from "../../../helpers/TextUtils";
import { ActionStatus, ActionType } from "../../reception/components/ActionAdd";
import IconArrowDown from '../../../assets/images/ic_arrow_down.png';
import IconArrowUp from '../../../assets/images/ic_arrow_up.png';
import IconEdit from '../../../assets/images/icon-edit.png';
import IconPlus from '../../../assets/images/icon-plus.png';

const TABS = [
    {
        value: 'action',
        label: "Hoạt động"
    },
    {
        value: 'history',
        label: "Lịch sử"
    }

]

const ActionLabel = [
    {
        value: 'view',
        label: "Xem "
    },
    {
        value: 'add',
        label: "Tạo đặt lịch"
    },
    {
        value: 'edit',
        label: "Cập nhật"
    },
    {
        value: 'editStatus',
        label: "Cập nhật trạng thái"
    },
    {
        value: 'delete',
        label: "Xóa lịch"
    }

]


const Action = (props: any) => {
    const { data } = props;
    const ActionItem = ({ item }: any) => {
        const [showMorre, setShowMore] = useState(false);
        const dataUpdate = {
            id: item?.id,
            action_user_uid: item?.action_user_uid?.id,
            examination_id: item?.examination_id?.id,
            type: item?.type,
            day: moment(item?.day).valueOf(),
            content: item?.content,
        }
        let checkExpired = moment().isAfter(item?.day);
        let checkDone = item?.status === 1 || item?.status === -1
        if (item?.status === 1 || item?.status === -1) checkExpired = false

        const getColorByType = (status: any) => {
            switch (status) {
                case 0:
                    if (checkExpired) {
                        return '#FF1493';
                    } else {
                        return 'black';
                    }
                case 1:
                    return 'green';
                case -1:
                    return 'red';
                default:
                    return 'black';
            }
        };
        return (
            <>
                <tr>
                    <td className="text-center" onClick={() => setShowMore(!showMorre)}>
                        <div className='sub-count-container'>
                            <div style={{ flex: 1 }}> {TextUtils.getLabelByValue(ActionType, item?.type)}</div>
                            <div style={{ flex: 1 }} className='sub-count-action'>
                                <img style={{ border: 'none' }} src={showMorre ? IconArrowUp : IconArrowDown} width={20} height={20} alt="" />
                            </div>
                        </div>
                    </td>
                    <td className="text-center" onClick={() => setShowMore(!showMorre)}> <span style={{ color: getColorByType(item?.status) }}>{item?.status == 0 && checkExpired ? "Trễ" : TextUtils.getLabelByValue(ActionStatus, item?.status)}</span> </td>
                    <td className="text-center" onClick={() => setShowMore(!showMorre)}>{item?.action_user_uid?.name}</td>
                    <td className={`text-center ${(checkExpired && !checkDone) ? 'text-danger' : (!checkExpired && !checkDone) ? 'text-success' : ''}`} onClick={() => setShowMore(!showMorre)}>{item?.day ? moment(item?.day).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">
                        <div className="table-action" style={{ justifyContent: 'center' }}>
                            {item?.status == 0 &&
                                <>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'editAction', data: item })}><img style={{ border: 'none' }} src={IconEdit} width={20} height={20} alt="" /></div>
                                    <div className="button-nutri" onClick={() => props?.handleActionModal({ type: 'deleteAction', data: item })}><i className='uil-trash-alt'></i></div>
                                </>
                            }
                        </div>
                    </td>
                </tr>
                {showMorre &&
                    <tr>
                        <td colSpan={5}>
                            <div className="p-2">
                                <p>
                                    <span className="mr-4"><b>Người tạo:</b> {props?.user?.name}</span>
                                    <span><b>Ngày tạo:</b> {item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'} </span><br />
                                    <b>Kết quả:</b> {item?.content || '---'} <br />
                                    {
                                        item?.next_customer_action_id != null && <div>
                                            <b>Hoạt động tiếp theo:</b> <span style={{ color: "#3183FF" }}>{item?.next_customer_action_id?.action_user_uid?.code || '---'}</span> <br />
                                        <b>Loại hoạt động:</b> {
                                            TextUtils.getLabelByValue(ActionType, item?.type) || '---'
                                        } <br />
                                        <b>Thời gian :</b> {moment(item?.day).format('DD/MM/YYYY') || '---'} <br />
                                        <b>Người thực hiện :</b> {item?.action_user_uid?.name || "---"}
                                        </div>
                                        
                                    }
                                   
                                    {item?.status === 0 &&
                                        <div className="mt-2">
                                            <Button style={{ minWidth: 120 }} onClick={() => props?.handleActionModal({ type: "rejectAction", data: dataUpdate })} className="danger-bland" color="success" type="button" >Thất bại</Button>
                                            <Button style={{ minWidth: 120 }} onClick={() => props?.handleActionModal({ type: "activeAction", data: dataUpdate })} className="ml-2 success-bland" color="success" type="button" >Thành công</Button>
                                        </div>}
                                </p>
                            </div>
                        </td>
                    </tr>}
            </>
        )
    }

    return (
        <div className="table-responsive">
            <table className="mb-0 table-custom no-bg table table-input" >
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '20%' }}>Loại hoạt động</th>
                        <th className="text-center" style={{ width: '20%' }}>Trạng thái</th>
                        <th className="text-center" style={{ width: '20%' }}>Người thực hiện</th>
                        <th className="text-center" style={{ width: '20%' }}>Thời hạn</th>
                        <th className="text-center" style={{ width: '20%' }}>Tháo tác</th>
                    </tr>
                </thead>
                {(data?.length === 0 || !data) ?
                    <RowEmpty column={5} title="Chưa có hoạt động nào!" /> :
                    <tbody>
                        {
                            data?.map((item: any, index: number) => (
                                <ActionItem
                                    item={item}
                                />
                            ))
                        }
                    </tbody>
                }

            </table>
        </div>
    )
}

const History = (props: any) => {
    const { data } = props

    const HistoryItem = ({ item }: any) => {
        if (item?.action) {
            const title = TextUtils.getLabelByValue(ActionLabel, item?.action)
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.created_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.created_uid?.name}</td>
                    <td className="text-center">{title}</td>
                </tr>
            )
        }
        if (item?.status === -1) {
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.updated_uid?.name}</td>
                    <td className="text-center">Từ chối</td>
                </tr>
            )
        }
        if (item?.updated_uid && item?.status === 1) {
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.updated_uid?.name}</td>
                    <td className="text-center">Duyệt</td>
                </tr>
            )
        }
        if (item?.updated_uid) {
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.updated_uid?.name}</td>
                    <td className="text-center">Chỉnh sửa</td>
                </tr>
            )
        }
        if (item?.status === 1) {
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.created_uid?.name}</td>
                    <td className="text-center">Tạo đặt lịch</td>
                </tr>
            )
        }
        if (item?.status === 0) {
            return (
                <tr>
                    <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                    <td className="text-center">{item?.updated_uid?.name || item?.created_uid?.name}</td>
                    <td className="text-center">Lưu nháp</td>
                </tr>
            )
        }
        return (
            <tr>
                <td className="text-center">{item?.created_time ? moment(item?.updated_time).format('HH:mm DD/MM/YYYY') : '---'}</td>
                <td className="text-center">{item?.created_uid?.name}</td>
                <td className="text-center">Tạo mới</td>
            </tr>
        )
    }
    return (
        <div className="table-responsive">
            <table className="mb-0 table-custom no-bg table table-input responsive" >
                <thead>
                    <tr>
                        <th className="text-center" style={{ width: '30%' }}>Thời gian</th>
                        <th className="text-center" style={{ width: '30%' }}>Người thực hiện</th>
                        <th className="text-center" style={{ width: '30%' }}>Hành động</th>
                    </tr>
                </thead>
                {(data?.length === 0 || !data) ?
                    <RowEmpty column={3} title="Chưa có Lịch sử nào!" /> :
                    <tbody>
                        {
                            data?.map((item: any, index: number) => (
                                <HistoryItem
                                    item={item}
                                />
                            ))
                        }
                    </tbody>
                }
            </table>
        </div>
    )
}


const CustomerTab = (props: any) => {
    const [tab, setTab] = useState('action');
    return (
        <div className="card">
            <div className="card-body">
                <Row>
                    <Col md={8}>
                        <NavTabNutri
                            {...props}
                            tabList={TABS}
                            setTab={(tab: string) => setTab(tab)}
                            tab={tab || 'action'}
                            classes="mt-3 mb-0 nav-tab-full"
                        />
                    </Col>
                    <Col md={4}>
                        {tab === 'debt' &&
                            <div className="text-right">
                                <UncontrolledDropdown className="align-self-center">
                                    <DropdownToggle
                                        data-toggle="dropdown"
                                        tag="button"
                                        className="btn btn-link p-0 dropdown-toggle mr-0">
                                        <Button color="success" className="ml-2">
                                            <i className='uil uil-plus mr-1'></i> Tạo phiếu thu/chi
                                        </Button>
                                    </DropdownToggle>
                                    <DropdownMenu right className="topbar-dropdown-menu profile-dropdown-items">
                                        <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({ type: 'addReceipts', data: {} })}>
                                            <span>Phiếu thu</span>
                                        </div>
                                        <DropdownItem divider />
                                        <div className="dropdown-item notify-item" onClick={() => props?.handleActionModal({ type: 'addPayment', data: {} })}>
                                            <span>Phiếu chi</span>
                                        </div>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        }
                        {tab === 'action' &&
                            <div className="text-right">
                                <Button onClick={() => props?.handleActionModal({ type: "addAction" })} color="success" className="ml-2"><img className='mr-1' style={{ border: 'none' }} src={IconPlus} width={20} height={20} alt="" />  Thêm</Button>
                            </div>
                        }
                    </Col>
                </Row>
                <div className="mt-4">
                    {tab === 'action' && <Action {...props} data={props?.dataAction} />}
                    {tab === 'history' && <History {...props} data={props?.history} />}
                </div>
            </div>
        </div>
    )
}

export default CustomerTab